<template>
  <div class="hello">
    <p>
      从屏幕左侧滑动，显示返回<br>
      <a href="https://github.com/cyyjs/demo" target="_blank">github</a>.
    </p>
  </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
